<template xmlns="http://www.w3.org/1999/html">
    <div class="login">
        <div class="login-card">
            <div class="login-card-left">
                <div class="form-wrap">
                    <router-view></router-view>
                </div>
                <div class="copyright" v-html="copyright"></div>
            </div>

            <div class="login-card-right">
                <div class="badge">FAT &middot; Админ портал</div>

                <div class="brand">
                    <h1>FAT</h1>
                </div>
                <p class="tagline">
                    Хаягдал өөх, тос цуглуулах тээвэрлэх систем.<br>
                    Тавтай морилно уу!
                </p>

                <div class="feature-list">
                    <a href="javascript:void(0)" @click="showInstructModal" class="feature-item">
                        <Icon type="md-checkmark-circle" />
                        <span>
                            <strong>Найдвартай</strong>
                            <small>Тогтвортой, аюулгүй үйл ажиллагаа</small>
                        </span>
                    </a>
                    <a href="/contact" target="_blank" class="feature-item">
                        <Icon type="md-git-compare" />
                        <span>
                            <strong>Уян хатан нөхцөлтэй</strong>
                            <small>Хамтран ажиллах уян хатан боломж</small>
                        </span>
                    </a>
                </div>

                <div class="status">
                    <span class="dot"></span>
                    Систем ажиллаж байна
                </div>
            </div>
        </div>

        <v-modal
            name="faq-modal"
            :pivot-y="0.5"
            :adaptive="true"
            :reset="true"
            :draggable="false"
            height="90%"
            width="70%"
        >
            <div class="d-modal">
                <div class="modal-header">
                    <h2 class="title">dd</h2>
                    <a
                        href="javascript:void(0)"
                        @click="$modal.hide('faq-modal')"
                        class="close"
                    >
                        <Icon type="ios-close" />
                    </a>
                </div>
                <div class="modal-body np">
                    <Spin v-if="isLoading" fix></Spin>
                    <Collapse simple style="text-align: left">
                        <Panel
                            v-for="item in faqs"
                            :key="item.index"
                            :name="item.index"
                        >
                            {{ item.title }}
                            <p slot="content">
                                <span v-html="item.content"></span>
                            </p>
                        </Panel>
                    </Collapse>
                </div>
            </div>
        </v-modal>

        <v-modal
            name="instruct-modal"
            :pivot-y="0.5"
            :adaptive="true"
            :reset="true"
            :draggable="false"
            height="90%"
            width="70%"
        >
            <div class="d-modal">
                <div class="modal-header">
                    <h2 class="title">title</h2>
                    <a
                        href="javascript:void(0)"
                        @click="$modal.hide('instruct-modal')"
                        class="close"
                    >
                        <Icon type="ios-close" />
                    </a>
                </div>
                <div class="modal-body np">
                    <p v-if="help" v-html="help.body"></p>
                </div>
            </div>
        </v-modal>
    </div>
</template>

<script>
import Vue from "vue";
import iView from "iview";
import vModal from "vue-js-modal";
import { loadLanguageAsync } from "../admin/locale";

Vue.use(iView);
Vue.use(vModal, { componentName: "v-modal" });

export default {
    data() {
        return {
            isLoading: false,
            loading: false,
            isSuccess: false,
            isError: false,
            credentials: {
                login: null,
                password: null,
            },
            copyright: window.lambda.copyright,
            windowsd: window.lambda.windowslink,
            androidd: window.lambda.androidlink,
            languages: window.lambda.languages,
            selectedLang: "mn_MN",
            lambda: window.lambda,
            faqs: [],
            help: null,
        };
    },

    mounted() {},
    created() {},
    methods: {
        switchLanguage(val) {
            console.log("swutch", val);
            this.selectedLang = val;
            loadLanguageAsync(val);
        },
        showFaqModal(row) {
            this.isLoading = false;
            if (this.faqs.length == 0) {
                this.getFaqs();
            }
            this.$modal.show("faq-modal");
        },

        showInstructModal(row) {
            if (this.faqs.length == 0) {
                this.getFaqs();
            }
            this.$modal.show("instruct-modal");
        },

        showDetail(item) {
            this.currentNews = item;
            this.isList = false;
        },

        goBack() {
            this.isList = true;
        },
    },
};
</script>

<style lang="scss">
@import "./style";
</style>
